export default {
  title: 'Schimbați parola',
  form: {
    email: {
      label: 'E-mail',
      placeholder: 'Introduceți e-mailul',
    },
    new_password: {
      label: 'Parolă nouă',
      placeholder: 'Introduceți parola',
      requirements: 'Parola trebuie să conțină 8 caractere, o literă mare și o cifră',
    },
    confirm_password: {
      label: 'Confirmare parolă nouă',
      placeholder: 'Confirmați parola',
    },
    error_messages: {
      missing_info: 'Informații lipsă',
    },
  },
  buttons: {
    change_password: 'Schimbați parola',
  },
};
